import { Injectable, Renderer2, RendererFactory2 } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class BodyScrollLockService {
  private renderer: Renderer2;
  private previousBodyOverflow = '';
  private previousBodyPaddingRight = '';
  private previousBodyPosition = '';
  private previousBodyTop = '';
  private previousBodyWidth = '';
  private previousScrollY = 0;
  private isLocked = false;

  constructor(rendererFactory: RendererFactory2) {
    this.renderer = rendererFactory.createRenderer(null, null);
  }

  lock(): void {
    if (this.isLocked || typeof document === 'undefined') {
      return;
    }

    const body = document.body;

    this.previousBodyOverflow = body.style.overflow;
    this.previousBodyPaddingRight = body.style.paddingRight;
    this.previousBodyPosition = body.style.position;
    this.previousBodyTop = body.style.top;
    this.previousBodyWidth = body.style.width;
    this.previousScrollY = typeof window !== 'undefined' ? window.scrollY || window.pageYOffset || 0 : 0;

    const scrollbarWidth = typeof window !== 'undefined' ? window.innerWidth - document.documentElement.clientWidth : 0;
    const currentPadding =
      typeof window !== 'undefined' ? parseInt(window.getComputedStyle(body).paddingRight, 10) || 0 : 0;
    this.renderer.setStyle(body, 'overflow', 'hidden');

    // Add scrollbar width to existing padding to prevent layout shift
    if (scrollbarWidth > 0) {
      this.renderer.setStyle(body, 'padding-right', `${currentPadding + scrollbarWidth}px`);
    }

    this.renderer.setStyle(body, 'position', 'fixed');
    this.renderer.setStyle(body, 'top', `-${this.previousScrollY}px`);
    this.renderer.setStyle(body, 'width', '100%');

    this.isLocked = true;
  }

  unlock(): void {
    if (!this.isLocked || typeof document === 'undefined') {
      return;
    }

    const body = document.body;

    // Restore previous styles
    this.restoreStyle(body, 'overflow', this.previousBodyOverflow);
    this.restoreStyle(body, 'padding-right', this.previousBodyPaddingRight);
    this.restoreStyle(body, 'position', this.previousBodyPosition);
    this.restoreStyle(body, 'top', this.previousBodyTop);
    this.restoreStyle(body, 'width', this.previousBodyWidth);

    this.isLocked = false;

    const scrollY = this.previousScrollY;
    this.previousScrollY = 0;

    if (typeof window !== 'undefined') {
      window.scrollTo({ top: scrollY });
    }
  }

  get locked(): boolean {
    return this.isLocked;
  }

  private restoreStyle(element: HTMLElement, property: string, value: string): void {
    if (value) {
      this.renderer.setStyle(element, property, value);
    } else {
      this.renderer.removeStyle(element, property);
    }
  }
}
